import {QuotationHistoryModel} from './quotation-history.model';

export class WorkingHistoryModel {
	workings: {
		causalType: string;
		createdAt: string;
		id: string;
		status: string;
		type: string;
		workingNumberPrefix: string;
		entry: QuotationHistoryModel[];
	} [];

	constructor(model: any) {
		this.workings = [];

		model.workings.forEach( working => {
			this.workings.push({
				causalType: working.causal_type,
				type: working.type,
				id: working.id,
				status: working.status,
				createdAt: working.created_at,
				workingNumberPrefix: working.working_number_prefix,
				entry: []
			})
		})
	}
}


